import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unclock-chapters',
  templateUrl: './unclock-chapters.component.html',
  styleUrls: ['./unclock-chapters.component.css']
})
export class UnclockChaptersComponent implements OnInit {
  showCoupon:boolean = false;
  showSubscription:boolean = false;
  showCoins:boolean = false;
  showRedeem:boolean = false;
  showFreeCount:boolean = false;
  copyCouponCode: any;
  public couponCode = "INFY10";
  constructor( private router:Router,
    private dialogRef: MatDialogRef<UnclockChaptersComponent>,    @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

  ngOnInit(): void {
    this.showCoins = this.data.popupType == 'coins';
    this.showSubscription = this.data.popupType == 'isToSubscribe'
    this.showFreeCount = this.data.popupType == '';
  }

  copyCoupon(coupon: any) {
    this.showCoupon = !this.showCoupon;
    this.copyCouponCode = coupon;
    navigator.clipboard.writeText(coupon);
  }

  buyProPlus() {
    this.dialogRef.close();
    localStorage.setItem('SelectedTab', 'subscriptionPackages');
    this.router.navigate(["/subscription/subscriptionPackages"])
  }

}
